import { render, staticRenderFns } from "./HelpResults.vue?vue&type=template&id=027c9fe8"
import script from "./HelpResults.vue?vue&type=script&lang=js"
export * from "./HelpResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports